// src/pages/Disclaimer.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function Disclaimer() {
  return (
    <div
      style={{
        maxWidth: 900,
        margin: "0 auto",
        padding: 24,
        fontFamily: "system-ui",
        lineHeight: 1.55,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <h2 style={{ margin: 0 }}>Disclaimer</h2>

        <div style={{ marginLeft: "auto", display: "flex", gap: 12, fontSize: 14 }}>
          <Link to="/stocks" style={{ textDecoration: "none" }}>Stocks</Link>
          <Link to="/etfs" style={{ textDecoration: "none" }}>ETFs</Link>
          <Link to="/holdings" style={{ textDecoration: "none" }}>Holdings</Link>
          <Link to="/feed" style={{ textDecoration: "none" }}>Feed</Link>
          <Link to="/disclaimer" style={{ textDecoration: "none" }}>Disclaimer</Link>
        </div>
      </div>

      <div style={{ marginTop: 16, color: "#666", fontSize: 13 }}>
        Last updated: {new Date().toLocaleDateString()}
      </div>

      <div style={{ marginTop: 18, border: "1px solid #eee", borderRadius: 12, padding: 16 }}>
        <h3 style={{ marginTop: 0, marginBottom: 8 }}>Not Investment Advice</h3>
        <p style={{ marginTop: 0 }}>
          The information on this site is for informational and educational purposes only and does not
          constitute financial, investment, legal, tax, or trading advice.
        </p>
        <p>
          Any opinions expressed are my own and are not recommendations to buy, sell, or hold any
          security. You should conduct your own research and consult a qualified financial
          professional before making any investment decisions.
        </p>

        <hr style={{ border: "none", borderTop: "1px solid #f0f0f0", margin: "16px 0" }} />

        <h3 style={{ marginTop: 0, marginBottom: 8 }}>Data Sources &amp; Accuracy</h3>
        <p style={{ marginTop: 0 }}>
          Market data and financial information displayed on this site is aggregated from publicly
          available third-party sources and automated data feeds. While efforts are made to present
          accurate and up-to-date information, no guarantees are made regarding accuracy,
          completeness, timeliness, or reliability.
        </p>
        <p>
          Data may be delayed, estimated, incomplete, or subject to revision. This site should not
          be relied upon as a sole source for investment decisions.
        </p>
        <p style={{ marginBottom: 0 }}>
          This site makes no representations or warranties of any kind, express or implied, regarding
          the accuracy or suitability of the information provided.
        </p>
      </div>

      <div style={{ marginTop: 16, color: "#666", fontSize: 13 }}>
        <Link to="/stocks" style={{ textDecoration: "none" }}>← Back to Stocks</Link>
      </div>
    </div>
  );
}
